import React from 'react';

import {useI18n} from '../../../../../data/hooks/i18nHooks';
import {useMyUserId} from '../../../../../data/hooks/sessionHooks';
import ButtonLink from '../../../../elements/ButtonLink';

const EditAnswerButton = props => {
    const {event, answer} = props,
        i18n = useI18n();

    return (
        <ButtonLink
            type="button"
            className="buttonlink smallButton marginTop"
            href={'./' + answer.id}
            style={{
                width: '8em',
                ...event._local.styles.smallButton,
            }}>
            {i18n['label.edit']}
        </ButtonLink>
    );
};

export default EditAnswerButton;
